// =====================================================
// ST1 Sports — SEO hardening (v1)
// Self-contained, theme-update-proof.
//
// What it does, on every page:
//   1) Adds rel="nofollow noopener" to OUTBOUND (external) links,
//      EXCEPT your own social profiles (left as normal dofollow so you
//      keep referral tracking for traffic you drive to socials).
//   2) Backfills alt text on any <img> that is missing it (or has the
//      placeholder "Image alt"), deriving a sensible value from context.
//   Also re-runs on lazy/AJAX-loaded content via MutationObserver.
//
// HOW TO RE-APPLY AFTER A THEME UPDATE (2 steps):
//   1. Upload this file as: assets/st1-seo.js
//   2. In layout/theme.liquid, add ONE line just before </head>:
//        <script src="{{ 'st1-seo.js' | asset_url }}" defer></script>
// =====================================================
(function () {
  'use strict';

  // Links to these hosts are treated as INTERNAL (never touched).
  var INTERNAL_HOSTS = ['st1sports.com', 'shopify.com', 'myshopify.com'];

  // Your social profiles — kept as normal dofollow links (referral tracking preserved).
  var SOCIAL_HOSTS = [
    'instagram.com', 'facebook.com', 'fb.com', 'youtube.com', 'youtu.be',
    'tiktok.com', 'twitter.com', 'x.com', 'linkedin.com', 'lnkd.in',
    'pinterest.com', 'threads.net', 'snapchat.com'
  ];

  function hostMatches(host, list) {
    host = (host || '').toLowerCase();
    return list.some(function (d) { return host === d || host.endsWith('.' + d); });
  }

  function processLinks(root) {
    var anchors = (root.querySelectorAll ? root.querySelectorAll('a[href]') : []);
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      if (a.dataset.st1Seo) continue;
      var url;
      try { url = new URL(a.href, location.href); } catch (e) { continue; }
      if (!/^https?:$/.test(url.protocol)) continue;          // skip mailto:, tel:, #, etc.
      if (url.hostname === location.hostname) continue;        // same host (incl. preview domain)
      if (hostMatches(url.hostname, INTERNAL_HOSTS)) continue; // your own / Shopify infra
      a.dataset.st1Seo = '1';
      if (hostMatches(url.hostname, SOCIAL_HOSTS)) continue;   // leave socials dofollow
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      ['nofollow', 'noopener'].forEach(function (t) { if (rel.indexOf(t) === -1) rel.push(t); });
      a.setAttribute('rel', rel.join(' '));
    }
  }

  function deriveAlt(img) {
    var scope = img.closest('a, .product-card, .card, figure, li, .media, [class*="card"]') || img.parentElement;
    if (scope) {
      var t = scope.querySelector(
        '.card__heading, .product-card__title, figcaption, h1, h2, h3, h4, [class*="title"]'
      );
      if (t && t.textContent.trim()) return t.textContent.trim().replace(/\s+/g, ' ').slice(0, 125);
      var lbl = img.closest('a[aria-label]');
      if (lbl && lbl.getAttribute('aria-label')) return lbl.getAttribute('aria-label').trim().slice(0, 125);
    }
    if (img.getAttribute('title')) return img.getAttribute('title').trim().slice(0, 125);
    return (document.title || 'ST1 Sports').split('|')[0].trim().slice(0, 125) || 'ST1 Sports';
  }

  function processImages(root) {
    var imgs = (root.querySelectorAll ? root.querySelectorAll('img') : []);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      // Respect intentionally decorative images.
      if (img.getAttribute('role') === 'presentation' || img.getAttribute('aria-hidden') === 'true') continue;
      var alt = img.getAttribute('alt');
      var hasReal = alt !== null && alt.trim() !== '' && alt.trim().toLowerCase() !== 'image alt';
      if (hasReal) continue;
      var val = deriveAlt(img);
      if (val) img.setAttribute('alt', val);
    }
  }

  function run(root) {
    root = root || document;
    try { processLinks(root); } catch (e) {}
    try { processImages(root); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1) run(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
